import React, { useState } from "react";

const PaginationControl = ({ currentPage, totalPages, onPageChange }) => {
  const [showAllPages, setShowAllPages] = useState(false);

  return (
    <div className="d-flex justify-content-between align-items-center gap-2 mt-3 w-100">
      <button
        className="btn btn-sm btn-outline-secondary"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Prev
      </button>

      <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
        {showAllPages ? (
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                className={`btn btn-sm ${
                  currentPage === page ? "btn-primary" : "btn-outline-secondary"
                }`}
                onClick={() => {
                  onPageChange(page);
                  setShowAllPages(false);
                }}
              >
                {page}
              </button>
            ))}
          </div>
        ) : (
          <>
            {Array.from(
              { length: Math.min(3, totalPages) },
              (_, i) => i + 1
            ).map((page) => (
              <button
                key={page}
                className={`btn btn-sm ${
                  currentPage === page ? "btn-primary" : "btn-outline-secondary"
                }`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            ))}

            {totalPages > 3 && (
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowAllPages(true)}
              >
                ... {totalPages} halaman
              </button>
            )}
          </>
        )}
      </div>

      <button
        className="btn btn-sm btn-outline-secondary"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControl;
